import { Controller } from "@hotwired/stimulus"

// Filters a list of checkbox rows by text input.
// Expects: data-checkbox-filter-target="item" on each item row,
//          data-checkbox-filter-target="group" on each group wrapper,
//          data-name attribute on each item row for matching.
export default class extends Controller {
  static targets = ["input", "item", "group"]

  filter() {
    const query = this.inputTarget.value.toLowerCase().trim()

    this.itemTargets.forEach(item => {
      const name = (item.dataset.name || '').toLowerCase()
      const hide = query.length > 0 && !name.includes(query)
      item.classList.toggle('hidden', hide)
    })

    // Hide entire group wrapper when all its items are hidden
    this.groupTargets.forEach(group => {
      const items = group.querySelectorAll("[data-checkbox-filter-target='item']")
      const allHidden = items.length > 0 && [...items].every(i => i.classList.contains('hidden'))
      group.classList.toggle('hidden', allHidden)
    })
  }
}
